module.exports = __webpack_public_path__ + "media/ingredients/wheat--brown-01058852.svg";